/* These files are auto-generated, do not modify them. If you wish to modify certain assets, please use the sq-custom.css / sq-custom.js file */

function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};

window.sq.initSearch = (store) => {
  store.search();
};

window.sq.results = (store) => {
  // Get the filters from the store
  const filters = store.filters.find(
    (x) => x.stFieldName === "tags_color_tmf2kj3ckjoh7w94pw6rkf1j"
  )?.items;

  const results = store.results;

  if (!results) {
    console.log("results not found");
    return {};
  }

  // Handle the case where no filters are selected
  if (!filters || filters.length === 0) {
    console.log("No filters selected, returning all results");
    document.querySelectorAll(".on-load").forEach((e) => {
      e.innerHTML = `${store.totalHits} products`;
    });
    return { all: results }; // Return all results under a single key
  }

  // Map the filters to the desired structure
  const mappedData = filters.reduce((acc, filter) => {
    // Use the filter label as the key
    acc[filter.label] = results.filter((result) => {
      // Assuming results have a 'tags' property to match the filter value
      return result.tags_color_tmf2kj3ckjoh7w94pw6rkf1j?.includes(filter.label);
    });
    return acc;
  }, {});
  productCount(store,mappedData);
  console.log("mappedData is", mappedData);
  return mappedData;
};

function productCount(store,mappedData) {
  const totalLength = Object.values(mappedData).reduce(
    (sum, arr) => sum + arr.length,
    0
  );

  store.totalHits = totalLength;
  document.querySelectorAll(".on-load").forEach((e) => {
    e.innerHTML = `${totalLength} products`;
  });
}

window.onload = function () {
  const viewAllbtn = document.querySelector(".sq-view-all-btn");
  const head= document.querySelector(".sq-head");
  if (viewAllbtn) viewAllbtn.style.display = null;
  head.style.display = null;
  console.log("yoyo", viewAllbtn);
};
